import { FC, useMemo, useRef, useState } from 'react';
import { Grid, IconButton } from '@material-ui/core';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import AspectRatioIcon from '@material-ui/icons/AspectRatio';
import { useStyles } from './styles';
import exitFullScreen from '../../../../assets/streaming/overlay/full-screen-exit.svg';
import enterFullScreen from '../../../../assets/streaming/overlay/switch-to-full-screen-button.svg';
import aspectRatio from '../../../../assets/streaming/overlay/resize.svg';
import { RootReducer, StreamingReducer } from '../../../../models/Redux';
import { SET_LOCAL_STREAMING_STATE } from '../../../../store/actions/Streaming.actions';

interface VideoOverlayProps {
    isFullScreen: boolean;
    handleFullScreen: () => void;
}

const OVERLY_TIMER = 2 /* seconds */ * 1000; /* milliseconds */

const VideoOverlay: FC<VideoOverlayProps> = ({ isFullScreen, handleFullScreen }) => {
    const classes = useStyles();
    const [showOverlay, setShowOverlay] = useState<boolean>(false);
    const idleState = useRef<boolean>();
    const idleTimer = useRef<number>();
    const { localStreamingState } = useSelector<RootReducer, StreamingReducer>(state => state.streaming);
    const videoFitMode = useMemo(() => {
        return localStreamingState.videoFitMode;
    }, [localStreamingState.videoFitMode]);
    const dispatch = useDispatch();

    const triggerShowOverlay = (time: number) => {
        try {
            clearTimeout(idleTimer.current);
        } catch (e) {}
        if (!showOverlay) {
            setShowOverlay(true);
        }
        idleState.current = false;
        // @ts-ignore
        idleTimer.current = setTimeout(function () {
            setShowOverlay(false);
            idleState.current = true;
        }, time);
    };

    const handleChangeVideoFitMode = () => {
        if (videoFitMode === 'contain') {
            dispatch({
                type: SET_LOCAL_STREAMING_STATE,
                payload: {
                    ...localStreamingState,
                    videoFitMode: 'cover',
                },
            });
        } else {
            dispatch({
                type: SET_LOCAL_STREAMING_STATE,
                payload: {
                    ...localStreamingState,
                    videoFitMode: 'contain',
                },
            });
        }
    };

    return (
        <Grid
            container
            xs={12}
            justify="flex-end"
            alignContent="center"
            alignItems="center"
            direction="row"
            onMouseMove={() => {
                triggerShowOverlay(OVERLY_TIMER);
            }}
            className={clsx(classes.container)}
        >
            {showOverlay && (
                <Grid
                    container
                    xs={12}
                    justify="flex-end"
                    alignContent="center"
                    alignItems="center"
                    direction="row"
                    className={clsx(
                        classes.buttonContainer,
                        !isFullScreen ? classes.minimizedContainer : classes.maximizedContainer,
                    )}
                >
                    <IconButton onClick={handleChangeVideoFitMode} className={clsx(classes.iconButton)}>
                        {videoFitMode === 'contain' && <img src={aspectRatio} alt="Screen ratio" />}

                        {videoFitMode !== 'contain' && (
                            <AspectRatioIcon className={classes.icon} fill="white" />
                        )}
                    </IconButton>
                    <IconButton onClick={handleFullScreen} className={clsx(classes.iconButton)}>
                        <img src={isFullScreen ? exitFullScreen : enterFullScreen} alt="Full screen" />
                    </IconButton>
                </Grid>
            )}
        </Grid>
    );
};

export default VideoOverlay;
